const popupBtn = document.querySelector('.popup-hire-btn');
const popupHire = document.querySelector('.popup-hire');
const popupThanks = document.querySelector('.popup-thanks');
const popupCloseBtn = document.querySelector('.popup-hire .btn-close');
const overlay = document.querySelector('.overlay');

if(popupBtn) {
    popupBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if(popupHire) {
        document.body.classList.toggle('lock');
        overlay.classList.toggle('active');
        popupHire.classList.toggle('active');
      };
    });
    
    popupCloseBtn.addEventListener('click', (e) => {
      document.body.classList.remove('lock');
      overlay.classList.remove('active');
      popupHire.classList.remove('active');
    });

    overlay.addEventListener('click', (e) => {
        if(popupHire.classList.contains('active')) {
          popupHire.classList.remove('active');
          overlay.classList.remove('active');
        }
        if(popupThanks.classList.contains('active')) {
          popupThanks.classList.remove('active');
          overlay.classList.remove('active');
        }
    });
};